/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';

export const state = {
  index: null,
  edit: null,
  opsi: null,
};

export const mutations = {
  SET_INDEX(state, newValue) {
    state.index = newValue;
  },
  SET_EDIT(state, newValue) {
    state.edit = newValue;
  },
  SET_OPSI(state, newValue) {
    state.opsi = newValue;
  },
};
export const actions = {
  async fetch({ commit }, reset) {
    if (state.index && !reset) return Promise.resolve(state.index);

    const index = await http.get(`/psp/gtk/biodata`).then(({ data }) => data);

    commit('SET_INDEX', index || {});

    return Promise.resolve(index);
  },

  async fetchEdit({ commit }, reset) {
    if (state.edit && !reset) return Promise.resolve(state.edit);

    const index = await http.get(`/psp/gtk/biodata-edit`).then(({ data }) => data);

    commit('SET_EDIT', index || {});

    return Promise.resolve(index);
  },

  async option({ commit }, id) {
    if (state.opsi) return Promise.resolve(state.opsi);

    const { data } = await http.get(`psp/gtk/profil/${id}/opsi`).then(({ data }) => data);
    commit('SET_OPSI', data);
    return Promise.resolve(data);
  },

  actions({}, payloads) {
    let options = {};
    if (payloads.upload) {
      options = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
    }

    let endpoint = 'biodata';
    if (payloads.update) {
      endpoint = 'biodata-edit';
    }

    return http.post(`psp/gtk/${endpoint}/${payloads.action}`, payloads.params, options).then(({ data }) => data);
  },
};
